<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="
              md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100
            "
          >
            <h1 class="title" style="font-size: 5vw">
              THE GLOBAL VISION CONSTRUCTION INC
            </h1>
            <h4>
              Do you need professionals for your next construction project?
            </h4>
            <br />
            <a class="md-button md-danger md-theme-default" href="/#/contact">
              <md-button class="md-button md-danger md-theme-default"
                ><i class="fas fa-play"></i>Contact us
              </md-button></a
            >
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised" style="background-color: black">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="
                md-layout-item md-size-66 md-xsmall-size-100
                mx-auto
                text-center
              "
            >
              <h2 class="title text-center">Let's talk work</h2>
              <h5 class="description">
                The global vision construction inc is a leading young and
                professional construction services provider! If you have any
                questions or matters to discuss, our team is ready to assist
                you. Call us now!
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>chat</md-icon>
                  </div>
                  <h4 class="info-title">Excellence</h4>
                  <p>
                    We are a small company with great prospects. We specialize
                    in all types of framing, Interior Framing, Basement framing,
                    Decks and Demolition. Contact us to learn more about our
                    work.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>verified_user</md-icon>
                  </div>
                  <h4 class="info-title">Professionalism</h4>
                  <p>
                    Count on our experience, our perspective and above all with
                    the help you need to carry out everything you want to build.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>fingerprint</md-icon>
                  </div>
                  <h4 class="info-title">Work Experience</h4>
                  <p>
                    We have more than 5 years of professional experience, we
                    work in small teams, focused on exclusive projects that
                    allow us to develop our work faster.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <JavascriptComponents />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JavascriptComponents from "./components/JavascriptComponentsSection";
export default {
  bodyClass: "landing-page",
  components: {
    JavascriptComponents,
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/landing_gvc.jpg"),
    },
  },
  data() {
    return {
      classicModal: false,
      name: null,
      email: null,
      message: null,
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
